{
  "fr": {
    "courseEnrollments": {
      "headers": {
        "title": "Mes formations"
      },
      "tabs": {
        "active": "Actif",
        "bookmarked": "Enregistré",
        "inProgress": "En cours",
        "completed": "Terminé"
      },
      "empty": {
        "noEnrollments": "Vous n'êtes actuellement inscrit·e à aucune formation.",
        "noInProgress": "Vous n'avez actuellement aucune formation en cours.",
        "noBookmarked": "Vous n'avez pas encore enregistré de formations.",
        "noCompleted": "Vous n'avez pas encore terminé de formation.",
        "showAllCourses": "Afficher toutes les formations dans le catalogue de formations"
      }
    }
  }
}
